import TopNavbar from "./TopNavbar";
import '../assets/css/style.css';
import madan from '../assets/images/madan.webp';
import YouTubeIcon from '@material-ui/icons/YouTube';
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import { Helmet } from "react-helmet-async";
import Footer from "./Footer";

export default function AboutUS() {
    return (
        <>
        <Helmet>
            <title>About Us - Easy Data Structures</title>
            <meta name="description" content="Discover Easy Data Structures — your platform for simplified data structures tutorials, coding guides, learning resources, and beginner-friendly DSA explanations." />
            <link rel="canonical" href="https://easydatastructures.com/aboutus" />
            <script type="application/ld+json">{JSON.stringify(
            {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Easy Data Structures",
            "url": "https://easydatastructures.com/",
            "logo": "https://easydatastructures.com/easyDS-easydatastructures-logo.webp",
            "sameAs": [
                "https://www.facebook.com/EasyDataStructures",
                "https://www.instagram.com/easydatastructures",
                "https://www.youtube.com/@visualhow",
                "https://www.linkedin.com/company/easydatastructures",
                "https://github.com/madanlal1",
                "https://easydatastructures.com/"
            ]
            }
            )}
            </script>
            <script type="application/ld+json">{JSON.stringify(
            {
            "@context": "https://schema.org/",
            "@type": "Person",
            "name": "Madan Lal",
            "url": "https://madanlal1.github.io/Profile-Portfolio/",
            "image": "https://avatars.githubusercontent.com/u/81483460?v=4",
            "sameAs": [
                "https://www.youtube.com/@visualhow",
                "https://www.linkedin.com/company/easydatastructures",
                "https://github.com/madanlal1",
                "https://easydatastructures.com/"
            ]  
            }
            )}
            </script>
            <script type="application/ld+json">{JSON.stringify(
            {
            "@context": "https://schema.org/",
            "@type": "WebSite",
            "name": "Easy Data Structures",
            "url": "https://easydatastructures.com/aboutus/",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "https://easydatastructures.com/aboutus/search?q=keyword{search_term_string}",
                "query-input": "required name=search_term_string"
            }
            }
            )}
            </script>
            <script type="application/ld+json">{JSON.stringify(
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                {
                    "@type": "Question",
                    "name": "What is Easy Data Structures?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Easy Data Structures is an online platform that provides simple explanations, visuals, tutorials, and real-world examples of data structures and algorithms to help students and developers learn quickly."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Who can learn from Easy Data Structures?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The website is designed for beginners, computer science students, job seekers preparing for technical interviews, and developers who want to refresh their knowledge of data structures."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Are the tutorials suitable for coding interview preparation?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, the tutorials and examples on Easy Data Structures cover the core concepts frequently asked in technical interviews, including arrays, linked lists, stacks, queues, trees, graphs, and algorithms."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Is Easy Data Structures free to use?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, all the explanations and learning material on Easy Data Structures are freely available for students and developers."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Which data structures can I learn on this website?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You can learn core data structures such as arrays, linked lists, stacks, queues, trees, heaps, hash tables, graphs, and more, along with visual examples and use cases."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Does Easy Data Structures offer real-world examples?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, each topic includes simple, real-world examples to help you understand how data structures are used in actual applications."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Can beginners understand the explanations easily?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely. The content is written in simple language with diagrams and step-by-step explanations, making it ideal for beginners."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Do I need coding experience to start?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "No prior coding experience is required. The website starts with the basics and gradually introduces you to more advanced concepts."
                    }
                }
                ]
            }
            )}
            </script>
        </Helmet>
        <TopNavbar/>
        <div className="row aboutus g-0">
        <div className='outerDiv'>

                <div className="row g-0">

                    <div className="col" style={{ display: 'flex', justifyContent: 'center' }}>
                        <img src={madan} alt="developer pic" className="center" style={{ borderRadius: '270px' }} width="180px" height="180px" />
                    </div>

                </div>
                <div className="row g-0">

                    <div className="col" style={{ display: 'grid', justifyContent: 'center', textAlign :'center' }}>
                        <h2>Madan Lal</h2>
                        <h4>Software Engineer</h4><br/>
                        <p><strong><i>"Don't Complain of Darkness, Light a Candle."</i></strong></p>
                        <p><strong><i>Prof. Nisar Ahmed Siddiqui</i></strong></p>
                        <br />
                        <h5>Follow Us on Social Media</h5>
                        <div>
                            <a target='_blank' href="https://www.youtube.com/@visualhow/videos">
                                <YouTubeIcon className="youtube-icon" style={{fontSize:"40px", margin:'5px', color:'#c4302b'}}/>
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.facebook.com/EasyDataStructures"
                                >
                                <FacebookIcon className="facebook-icon"
                                    style={{ fontSize: "40px", margin: "5px", color: "#1877F2" }}
                                />
                            </a>

                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.instagram.com/easydatastructures"
                                >
                                <InstagramIcon className="instagram-icon"
                                    style={{ fontSize: "40px", margin: "5px", color: "#E4405F" }}
                                />
                                </a>

                                <a target='_blank' href="https://www.linkedin.com/company/easydatastructures">
                                    <LinkedInIcon className="linkedin-icon" style={{fontSize:"40px", margin:'5px', color:'#0A66C2'}}/>
                                </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <Footer/>
        </>
    )
}